import styled, { createGlobalStyle } from 'styled-components';

export const Header = styled.header`
    height: 80px;
    padding: 15px 5px;
    line-height: 1;
    display: flex;
    justify-content: space-between;

    .logo {
        text-decoration: none;
    }

    .poweredby {
        display: flex;
        justify-content: center;
        align-items: center;
        span {
            margin-right: 10px;
        }
    }

    a: link {
        text-decoration: none;
    }

    @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
            props.theme.large}) {
        .logo {
            max-width: 135px;
            span {
                font-size: 12px;
            }
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        &.conteneur {
            height: 40px;
            padding: 5px 20px;
        }
        .logo {
            margin-right: auto;
            svg {
                width: 110px;
                height: auto;
            }
        }
        .poweredby {
            display: none;
        }
    }
`;

export const HeaderGlobalStyle = createGlobalStyle`
    @media screen and (max-width: ${props => props.theme.mobile}) {
        /*** bouton menu mobile***/
        .menu-mobile-bt {
            position: relative;
            top: 0;
            padding: 0;
            margin: 0;
            border: none;
            background: none;
            width: 20px;
            height: 20px;
            cursor: pointer;
            transition: transform 0.2s cubic-bezier(0.16, 0.49, 0.42, 0.99);
            outline: none;
            overflow: hidden;
            cursor: pointer;
            z-index: 7;
        }
        .menu-mobile-bt:before,
        .menu-mobile-bt:after,
        .menu-mobile-bt span {
            display: block;
            background: ${props => props.theme.navMobIcon};
            width: 20px;
            height: 2px;
            transition: transform 0.2s cubic-bezier(0.16, 0.49, 0.42, 0.99);
        }
        .menu-mobile-bt:before,
        .menu-mobile-bt:after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            margin: auto;
        }
        .menu-mobile-bt:before {
            transform: translateY(-6px);
        }
        .menu-mobile-bt:after {
            transform: translateY(6px);
        }
        .menu-mobile-bt span {
            transform: translateX(0);
        }
        .open.menu-mobile-bt {
            position: fixed;
            top: 0;
            right: 20px;
            padding: 15px;
            width: 50px;
            height: 50px;
            transform: rotate(360deg);
        }
        .open.menu-mobile-bt:before,
        .open.menu-mobile-bt:after {
            transform-origin: center right;
            width: 10px;
            right: 15px;
        }
        .open.menu-mobile-bt:before {
            transform: rotate(45deg);
        }
        .open.menu-mobile-bt:after {
            transform: rotate(-45deg);
        }
        /*** slide menu mobile ***/
        body .entete .menu-mobile-slide {
            height: 100%;
            position: fixed;
            z-index: 5;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;
            transform: translateX(100%);
            background: rgba(0, 0, 0, 0.5);
            padding-left: 40px;
            transition: transform 0.2s cubic-bezier(0.16, 0.49, 0.42, 0.99);
        }
        body .entete .menu-mobile-slide.open {
            transform: translateX(0);
        }
        body .entete .menu-mobile-slide-conteneur {
            background: ${props => props.theme.navBackgroundColor};
            height: 100%;
            width: 100%;
        }
        body .entete .menu-mobile-slide-titre {
            height: 51px;
        }
        body .entete .menu-mobile-slide-ss-titre {
            margin: 20px 0;
        }
        .register-mobile {
            overflow-y: auto;
            height: 85%;
        }
        .btn-menu-mobile {
            margin-top: 10px;
        }
        .conteneur-mobile.form-menu-mobile {
            min-width: 280px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/header/minimal/MinimalHeaderComponentStyle.js